'use client';
import styled from 'styled-components';

export const StyledQuoteBlock = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: ${props => props.theme.spacing(7)};
  background-color: ${props => props.theme.colors.get(props.$backgroundColor)};
  border-radius: ${props => props.theme.spacing(4)};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(6)};
  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(8)};
    gap: ${props => props.theme.spacing(40)};
    max-width: 474px;
  }
`;

export const QuoteIconWrapperMobile = styled.div`
  display: block;
  position: absolute;
  right: 0;
  top: 0;

  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const QuoteIconWrapperDesktop = styled.div`
  display: none;

  @media ${props => props.theme.laptop} {
    display: block;
    padding-bottom: ${props => props.theme.spacing(5)};
  }
`;

export const StyledQuoteBodyContainer = styled.div`
  @media ${props => props.theme.laptop} {
    margin: ${props => props.theme.spacing(1)};
    padding: ${props => props.theme.spacing(1)};
  }
  margin-bottom: ${props => props.theme.spacing(2)};
  padding-bottom: ${props => props.theme.spacing(4)};
  p {
    ${props => props.theme.typography.largeBody}
    line-height: 1.625rem;
    color: ${props => props.theme.colors.text.primary};
  }
`;

export const StyledQuoteAuthorContainer = styled.div`
  display: flex;
  margin-top: auto;
  align-items: center;
  bottom: 0;
  gap: ${props => props.theme.spacing(2)};
`;

export const StyledQuoteImage = styled.div`
  flex: 0 0 48px;
  height: 48px;
  width: 48px;

  img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const StyledQuoteName = styled.div`
  ${props => props.theme.typography.smallHandwritten};
  color: ${props => props.theme.colors.neutral.dark};
`;

export const StyledQuoteTitle = styled.div`
  ${props => props.theme.typography.largeBody};
  color: ${props => props.theme.colors.text.tertiary};
  text-transform: none;
`;
